<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="hasExtraFilter"
        rounded
        color="primary"
        dark
        v-on="on"
        class="float-right mr-4"
      >
        Filtrar
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Filtrar por fecha</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <VAlert
            border="top"
            close-icon="$cancel"
            color="error"
            dismissible
            transition="scale-transition"
            :value="alert"
            >La fecha de inicio tiene que ser menor que la fecha de fin
          </VAlert>
          <v-row>
            <v-col cols="12" md="6">
              <h5 class="mb-2">Fecha inicial *</h5>
              <v-date-picker
                v-model="picker"
                color="primary"
                locale="es-es"
              ></v-date-picker>
            </v-col>
            <v-col cols="12" md="6">
              <h5 class="mb-2">Fecha final *</h5>
              <v-date-picker
                v-model="picker2"
                color="primary"
                locale="es-es"
              ></v-date-picker>
            </v-col>
          </v-row>
        </v-container>
        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="dialog = false">Cancelar </v-btn>
        <v-btn color="success" text @click="setExtraFilter">Filtrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BaseTableFilter",
  data() {
    return {
      picker: new Date().toISOString().substr(0, 10),
      picker2: new Date().toISOString().substr(0, 10),
      dialog: false,
      alert: false,
    };
  },
  props: {
    hasExtraFilter: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    setExtraFilter() {
      if (this.picker > this.picker2) {
        this.alert = true;
      } else {
        this.dialog = false;
        this.$emit("setExtraFilter", {
          picker: this.picker,
          picker2: this.picker2,
        });
      }
    },
  },
};
</script>

<style></style>
